/**
 * petloc – Wort-/Bildmarke
 * --------------------------------------------------------------------------
 * Pfote im Scan-Rahmen (Logo-Variante „P8"). Skaliert sauber von Favicon bis
 * groß. Farbe kommt über `currentColor` — Elternelement bestimmt sie via
 * `text-brand-600` o.ä.
 */

type MarkProps = {
  size?: number;
  className?: string;
};

/** Nur das Icon (Pfote im Scan-Rahmen). */
export function PetlocMark({ size = 32, className }: MarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g stroke="currentColor" strokeWidth="4.2" strokeLinecap="round" fill="none">
        <path d="M6 17V10a4 4 0 0 1 4-4h7" />
        <path d="M39 6h7a4 4 0 0 1 4 4v7" />
        <path d="M50 39v7a4 4 0 0 1-4 4h-7" />
        <path d="M17 50h-7a4 4 0 0 1-4-4v-7" />
      </g>
      <g fill="currentColor">
        <ellipse cx="20.5" cy="23" rx="3.7" ry="4.7" />
        <ellipse cx="35.5" cy="23" rx="3.7" ry="4.7" />
        <ellipse cx="14" cy="31.5" rx="3.2" ry="4" />
        <ellipse cx="42" cy="31.5" rx="3.2" ry="4" />
        <path d="M28 28.5c-5.2 0-9.4 3.6-9.4 8.2 0 3.4 2.9 5 6.2 5 1.6 0 2.4-.6 3.2-.6s1.6.6 3.2.6c3.3 0 6.2-1.6 6.2-5 0-4.6-4.2-8.2-9.4-8.2Z" />
      </g>
    </svg>
  );
}

/** Icon + Wortmarke nebeneinander (für Header). */
export function PetlocLogo({ size = 34 }: { size?: number }) {
  return (
    <span className="inline-flex items-center gap-[11px] text-brand-600">
      <PetlocMark size={size} />
      <span className="text-[20px] font-semibold tracking-[-0.02em] text-[#211019]">
        petloc<span className="text-[#A899A1] font-medium">.co</span>
      </span>
    </span>
  );
}
